import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarOrganizacao from '../../components/modal/ModalCadastrarOrganizacao';
import ModalEditarOrganizacao from '../../components/modal/ModalEditarOrganizacao';
import ModalExcluirOrganizacao from '../../components/modal/ModalExcluirOrganizacao';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function Organizacao() {
    const { Success, Error, openModal, setOpenModal, OrganizacoesConsulta, ListaOrganizacaoConsulta, loading, modalEditarOrganizacao, setModalEditarOrganizacao, setEdicaoOrganizacao, setOrganizacaoAtualKey, modalExcluirOrganizacao, setModalExcluirOrganizacao, InativarOrganizacao, ListaFiltroOrganizacao, totalRegistrosOrganizacao, filtroOrganizacao, totalRegistrosFiltroOrganizacao } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditOrganizacao = (props) => {
        setModalEditarOrganizacao(true)
        setOrganizacaoAtualKey(props.key)
        setEdicaoOrganizacao(props)
    }

    const DeletarOrganizacao = (props) => {
        setOrganizacaoAtualKey(props.key)
        setModalExcluirOrganizacao(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroOrganizacao(searchTerm, currentPage, pageSize);
        } else {
            ListaOrganizacaoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroOrganizacao : totalRegistrosOrganizacao;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar organizações'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarOrganizacao &&
                <ModalEditarOrganizacao currentPage={currentPage} />
            }
            {modalExcluirOrganizacao &&
                <ModalExcluirOrganizacao currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarOrganizacao closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar organização</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Organizações cadastradas</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroOrganizacao : OrganizacoesConsulta}
                            columns={[
                                { label: "Organização", field: "nome", width: "40%" },
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarOrganizacao(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditOrganizacao(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarOrganizacao(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroOrganizacao(term, 1, 10);
                                } else {
                                    ListaOrganizacaoConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Organizacao;